/* eslint-disable @typescript-eslint/no-explicit-any */

import { assert } from '../../utils/assert.js';
import { createUUIDv4 } from '../../utils/uuid.js';
import { GamoraErrorNotImplemented } from '../../errors/not-implemented.error.js';

/**
 * Input
 * @public
 */
export interface GamoraFoundationTaskInput {
  namespace?: string;
  name?: string;
}

/**
 * Default namespace
 * @public
 */
export const GamoraFoundationTaskDefaultNamespace = 'default';

/**
 * Task
 * @public
 */
export abstract class GamoraFoundationTask<
  T extends GamoraFoundationTaskInput,
> {
  protected _$namespace: string;
  protected _$name: string;

  /**
   * Constructs the task
   * @param input - The input
   */
  constructor(input: T) {
    assert(
      typeof input === 'object' && input !== null,
      'Invalid input argument: not an object.',
    );

    this._$name = input.name ?? createUUIDv4();
    this._$namespace = input.namespace ?? GamoraFoundationTaskDefaultNamespace;
  }

  /**
   * Get name
   */
  get $name(): string {
    return this._$name;
  }

  /**
   * Get namespace
   */
  get $namespace(): string {
    return this._$namespace;
  }

  /**
   * Check if task is running
   */
  get $isRunning(): boolean {
    throw new GamoraErrorNotImplemented();
  }

  /**
   * Start task
   */
  async $start(): Promise<any> {
    throw new GamoraErrorNotImplemented();
  }

  /**
   * Terminate task
   */
  async $terminate(): Promise<void> {
    throw new GamoraErrorNotImplemented();
  }
}
